import { render, staticRenderFns } from "./companyUserList.vue?vue&type=template&id=28c8440e&scoped=true&"
import script from "./companyUserList.vue?vue&type=script&lang=js&"
export * from "./companyUserList.vue?vue&type=script&lang=js&"
import style0 from "./companyUserList.vue?vue&type=style&index=0&id=28c8440e&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "28c8440e",
  null
  
)

export default component.exports